module.exports = __webpack_public_path__ + "img/security.d231564a.png";